import React from 'react';
import { ProductCard } from './ProductCard';
import { Button } from './Button';
export function FeaturedProducts() {
  const products = [{
    title: 'Daedo Gen 2 E-Trunk Protector (Hogu)',
    price: '$185.00',
    category: 'Protective Gear',
    image: 'https://cdn.magicpatterns.com/uploads/kfguP8tNDqA8zXYkxoyPcg/Gen2_E-Chest_Gear_Adult_Size.jpg'
  }, {
    title: 'Daedo Gen 2 Electronic Headgear',
    price: '$145.00',
    category: 'Head Gear',
    image: 'https://cdn.magicpatterns.com/uploads/oEDj2ZvCJJBgsVECUR8bR3/Gen2_E-HeadGear.jpg'
  }, {
    title: 'Daedo Electronic Foot Protector',
    price: '$65.00',
    category: 'E-Foot Gear',
    image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=9848&user=1373&w=400&h=400&file=uploaded%2Fimages%2FDaedo%2FGeneration2%2Fepro29037_1_optimizacionweb.jpg'
  }, {
    title: 'Daedo WT Approved Hand Protector',
    price: '$35.00',
    category: 'Gloves',
    image: 'https://cdn.magicpatterns.com/uploads/fFmeJSZ4XSZWsghGfFQJi4/Gen3_PSS-Gloves_USAT.png'
  }, {
    title: 'Daedo WT Approved Shin Guard',
    price: '$42.00',
    category: 'Protective Gear',
    image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=9848&user=1373&w=400&h=400&file=uploaded%2Fimages%2FWacoku%2FWTF%20B167.jpg800x800.jpg'
  }, {
    title: 'Daedo WT Approved Forearm Guard',
    price: '$38.00',
    category: 'Protective Gear',
    image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=9848&user=1373&w=400&h=400&file=uploaded%2Fimages%2FWacoku%2FWTF%20B166.jpg800x800.jpg'
  }, {
    title: 'Daedo V-Neck Taekwondo Uniform',
    price: '$55.00',
    category: 'Uniforms',
    image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=9848&user=1373&w=400&h=400&file=uploaded%2Fimages%2FRedesign%2FWacokuIntro.jpg'
  }, {
    title: 'Daedo Target Mitt (Double)',
    price: '$28.00',
    category: 'Training Gear',
    image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=9848&user=1373&w=400&h=400&file=uploaded%2Fimages%2FWacoku%2FB464%26B465.jpg800x800.jpg'
  }];
  return <section className="py-20 bg-gray-50" data-id="element-18">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-19">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-12" data-id="element-20">
          <div data-id="element-21">
            <h2 className="text-3xl font-black text-gray-900 uppercase tracking-tight" data-id="element-22">
              Featured Equipment
            </h2>
            <div className="w-24 h-1 bg-red-600 mt-4" data-id="element-23"></div>
            <p className="mt-4 text-gray-600 font-medium max-w-2xl" data-id="element-24">
              Top-rated Daedo gear trusted by athletes worldwide.
            </p>
          </div>
          <Button variant="secondary" className="mt-6 md:mt-0 hidden md:inline-flex" data-id="element-25">
            Shop All Products
          </Button>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-26">
          {products.map((product, index) => <ProductCard key={index} title={product.title} price={product.price} category={product.category} image={product.image} isNew={index < 2} data-id="element-27" />)}
        </div>

        <div className="mt-10 text-center md:hidden" data-id="element-28">
          <Button variant="secondary" className="w-full" data-id="element-29">
            Shop All Products
          </Button>
        </div>
      </div>
    </section>;
}